import type { BigNumberish } from '@ethersproject/bignumber';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useVenoSDK } from '@ui/providers/VenoSDKProvider';
import { QueryKey } from '@ui/queries/queryKey';

import { useCoinMode } from './useCoinMode';
import { useLiquidCoinBalance } from './useLiquidCoinBalance';

const useRequestUnbond = () => {
  const coinMode = useCoinMode();
  const queryClient = useQueryClient();
  const sdk = useVenoSDK();

  return useMutation(
    ({ receiver, amount }: { receiver: string; amount: BigNumberish }) => {
      if (coinMode === 'eth') {
        return sdk.LiquidEth.requestUnbond(amount, receiver);
      }
      return coinMode === 'atom'
        ? sdk.LiquidAtom.requestUnbond(amount, receiver)
        : sdk.LiquidCro.requestUnbond(amount, receiver);
    },
    {
      onSuccess: async (data) => {
        await data.txReceiptPromise;

        queryClient.invalidateQueries(useLiquidCoinBalance.queryKey(coinMode));
        queryClient.invalidateQueries([QueryKey.GET_NFT_TOKENS]);
      },
    },
  );
};

export default useRequestUnbond;
